import { Directive, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudDataSource, CrudListComponent, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { ASSET_TYPE, ASSET_TYPE_METADATA, ASSET_TYPE_TYPE, Asset, AssetType, AssetsUser, BUSINESS_UNIT_METADATA, BUSINESS_UNIT_TYPE, BusinessUnit, COST_CENTRE_METADATA, COST_CENTRE_TYPE, CostCentre, MECHANICAL_ASPECT_METADATA, MECHANICAL_ASPECT_TYPE, MechanicalAspect, RefCode } from 'assets-model';
import { AssetDataSource, AssetService, AssetTypeService, BusinessUnitService, CostCentreService, MechanicalAspectService, RefCodeStorage } from 'assets-service';


@Directive()
export abstract class AssetSearchComponentBase extends CrudListComponent<Asset, number> {
  protected systemConfig: any;

  reportRun: any = {};

  displayedColumns: string[] = [ 'assetId', 'assetType.assetTypeId', 'businessUnit.buId', 'costCentre.ccId', 'mechanicalAspect.aspectAssetId', 'comments', 'composedAssetClass', 'createdBy', 'createdDate', 'description', 'identityReference', 'importDataMap', 'latestRoutineMaintenanceDate', 'location', 'lockVersion', 'manufacturer', 'model', 'nextRoutineMaintenanceRequiredDate', 'nextRoutineMaintenanceWarningDate', 'purchaseDate', 'purchasePrice', 'status', 'updatedBy', 'updatedDate', 'actions'];

  public searchForm: FormGroup;

  assetIdFilter: number;
  @ViewChild('assetIdFilterInput') assetIdFilterInput: ElementRef;

  assetTypeFilter: AssetType;
  assetTypeSelectionList: AssetType[];
  @ViewChild('assetTypeFilterInput') assetTypeFilterInput: MatSelect;

  businessUnitFilter: BusinessUnit;
  businessUnitSelectionList: BusinessUnit[];
  @ViewChild('businessUnitFilterInput') businessUnitFilterInput: MatSelect;

  costCentreFilter: CostCentre;
  costCentreSelectionList: CostCentre[];
  @ViewChild('costCentreFilterInput') costCentreFilterInput: MatSelect;

  mechanicalAspectFilter: MechanicalAspect;
  mechanicalAspectSelectionList: MechanicalAspect[];
  @ViewChild('mechanicalAspectFilterInput') mechanicalAspectFilterInput: MatSelect;

  commentsFilter: string;
  @ViewChild('commentsFilterInput') commentsFilterInput: ElementRef;

  composedAssetClassSelectionList: RefCode[];
  composedAssetClassFilter: string;
  @ViewChild('composedAssetClassFilterInput') composedAssetClassFilterInput: MatSelect;

  createdByFilter: string;
  @ViewChild('createdByFilterInput') createdByFilterInput: ElementRef;

  createdDateFilter: Date;
  @ViewChild('createdDateFilterInput') createdDateFilterInput: ElementRef;
  createdDateLessThanFilter: Date;
  @ViewChild('createdDateLessThanFilterInput') createdDateLessThanFilterInput: ElementRef;
  createdDateLessThanOrEqualToFilter: Date;
  @ViewChild('createdDateLessThanOrEqualToFilterInput') createdDateLessThanOrEqualToFilterInput: ElementRef;
  createdDateGreaterThanFilter: Date;
  @ViewChild('createdDateGreaterThanFilterInput') createdDateGreaterThanFilterInput: ElementRef;
  createdDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('createdDateGreaterThanOrEqualToFilterInput') createdDateGreaterThanOrEqualToFilterInput: ElementRef;

  descriptionFilter: string;
  @ViewChild('descriptionFilterInput') descriptionFilterInput: ElementRef;

  identityReferenceFilter: string;
  @ViewChild('identityReferenceFilterInput') identityReferenceFilterInput: ElementRef;

  latestRoutineMaintenanceDateFilter: Date;
  @ViewChild('latestRoutineMaintenanceDateFilterInput') latestRoutineMaintenanceDateFilterInput: ElementRef;
  latestRoutineMaintenanceDateLessThanFilter: Date;
  @ViewChild('latestRoutineMaintenanceDateLessThanFilterInput') latestRoutineMaintenanceDateLessThanFilterInput: ElementRef;
  latestRoutineMaintenanceDateLessThanOrEqualToFilter: Date;
  @ViewChild('latestRoutineMaintenanceDateLessThanOrEqualToFilterInput') latestRoutineMaintenanceDateLessThanOrEqualToFilterInput: ElementRef;
  latestRoutineMaintenanceDateGreaterThanFilter: Date;
  @ViewChild('latestRoutineMaintenanceDateGreaterThanFilterInput') latestRoutineMaintenanceDateGreaterThanFilterInput: ElementRef;
  latestRoutineMaintenanceDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('latestRoutineMaintenanceDateGreaterThanOrEqualToFilterInput') latestRoutineMaintenanceDateGreaterThanOrEqualToFilterInput: ElementRef;

  locationFilter: string;
  @ViewChild('locationFilterInput') locationFilterInput: ElementRef;

  manufacturerFilter: string;
  @ViewChild('manufacturerFilterInput') manufacturerFilterInput: ElementRef;

  modelFilter: string;
  @ViewChild('modelFilterInput') modelFilterInput: ElementRef;

  nextRoutineMaintenanceRequiredDateFilter: Date;
  @ViewChild('nextRoutineMaintenanceRequiredDateFilterInput') nextRoutineMaintenanceRequiredDateFilterInput: ElementRef;
  nextRoutineMaintenanceRequiredDateLessThanFilter: Date;
  @ViewChild('nextRoutineMaintenanceRequiredDateLessThanFilterInput') nextRoutineMaintenanceRequiredDateLessThanFilterInput: ElementRef;
  nextRoutineMaintenanceRequiredDateLessThanOrEqualToFilter: Date;
  @ViewChild('nextRoutineMaintenanceRequiredDateLessThanOrEqualToFilterInput') nextRoutineMaintenanceRequiredDateLessThanOrEqualToFilterInput: ElementRef;
  nextRoutineMaintenanceRequiredDateGreaterThanFilter: Date;
  @ViewChild('nextRoutineMaintenanceRequiredDateGreaterThanFilterInput') nextRoutineMaintenanceRequiredDateGreaterThanFilterInput: ElementRef;
  nextRoutineMaintenanceRequiredDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('nextRoutineMaintenanceRequiredDateGreaterThanOrEqualToFilterInput') nextRoutineMaintenanceRequiredDateGreaterThanOrEqualToFilterInput: ElementRef;

  nextRoutineMaintenanceWarningDateFilter: Date;
  @ViewChild('nextRoutineMaintenanceWarningDateFilterInput') nextRoutineMaintenanceWarningDateFilterInput: ElementRef;
  nextRoutineMaintenanceWarningDateLessThanFilter: Date;
  @ViewChild('nextRoutineMaintenanceWarningDateLessThanFilterInput') nextRoutineMaintenanceWarningDateLessThanFilterInput: ElementRef;
  nextRoutineMaintenanceWarningDateLessThanOrEqualToFilter: Date;
  @ViewChild('nextRoutineMaintenanceWarningDateLessThanOrEqualToFilterInput') nextRoutineMaintenanceWarningDateLessThanOrEqualToFilterInput: ElementRef;
  nextRoutineMaintenanceWarningDateGreaterThanFilter: Date;
  @ViewChild('nextRoutineMaintenanceWarningDateGreaterThanFilterInput') nextRoutineMaintenanceWarningDateGreaterThanFilterInput: ElementRef;
  nextRoutineMaintenanceWarningDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('nextRoutineMaintenanceWarningDateGreaterThanOrEqualToFilterInput') nextRoutineMaintenanceWarningDateGreaterThanOrEqualToFilterInput: ElementRef;

  purchaseDateFilter: Date;
  @ViewChild('purchaseDateFilterInput') purchaseDateFilterInput: ElementRef;
  purchaseDateLessThanFilter: Date;
  @ViewChild('purchaseDateLessThanFilterInput') purchaseDateLessThanFilterInput: ElementRef;
  purchaseDateLessThanOrEqualToFilter: Date;
  @ViewChild('purchaseDateLessThanOrEqualToFilterInput') purchaseDateLessThanOrEqualToFilterInput: ElementRef;
  purchaseDateGreaterThanFilter: Date;
  @ViewChild('purchaseDateGreaterThanFilterInput') purchaseDateGreaterThanFilterInput: ElementRef;
  purchaseDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('purchaseDateGreaterThanOrEqualToFilterInput') purchaseDateGreaterThanOrEqualToFilterInput: ElementRef;

  purchasePriceFilter: number;
  @ViewChild('purchasePriceFilterInput') purchasePriceFilterInput: ElementRef;
  purchasePriceLessThanFilter: number;
  @ViewChild('purchasePriceLessThanFilterInput') purchasePriceLessThanFilterInput: ElementRef;
  purchasePriceLessThanOrEqualToFilter: number;
  @ViewChild('purchasePriceLessThanOrEqualToFilterInput') purchasePriceLessThanOrEqualToFilterInput: ElementRef;
  purchasePriceGreaterThanFilter: number;
  @ViewChild('purchasePriceGreaterThanFilterInput') purchasePriceGreaterThanFilterInput: ElementRef;
  purchasePriceGreaterThanOrEqualToFilter: number;
  @ViewChild('purchasePriceGreaterThanOrEqualToFilterInput') purchasePriceGreaterThanOrEqualToFilterInput: ElementRef;

  statusSelectionList: RefCode[];
  statusFilter: string;
  @ViewChild('statusFilterInput') statusFilterInput: MatSelect;

  updatedByFilter: string;
  @ViewChild('updatedByFilterInput') updatedByFilterInput: ElementRef;

  updatedDateFilter: Date;
  @ViewChild('updatedDateFilterInput') updatedDateFilterInput: ElementRef;
  updatedDateLessThanFilter: Date;
  @ViewChild('updatedDateLessThanFilterInput') updatedDateLessThanFilterInput: ElementRef;
  updatedDateLessThanOrEqualToFilter: Date;
  @ViewChild('updatedDateLessThanOrEqualToFilterInput') updatedDateLessThanOrEqualToFilterInput: ElementRef;
  updatedDateGreaterThanFilter: Date;
  @ViewChild('updatedDateGreaterThanFilterInput') updatedDateGreaterThanFilterInput: ElementRef;
  updatedDateGreaterThanOrEqualToFilter: Date;
  @ViewChild('updatedDateGreaterThanOrEqualToFilterInput') updatedDateGreaterThanOrEqualToFilterInput: ElementRef;


  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected assetService: AssetService,
    protected assetTypeService: AssetTypeService,
    protected businessUnitService: BusinessUnitService,
    protected costCentreService: CostCentreService,
    protected mechanicalAspectService: MechanicalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(ASSET_TYPE, route, router, userStorage, dialog, assetService, injector);

    this.searchForm = this.fb.group({
      assetId: [null],
      assetType: [null],
      businessUnit: [null],
      costCentre: [null],
      mechanicalAspect: [null],
      comments: [null],
      composedAssetClass: [null],
      createdBy: [null],
      createdDateLessThan: [null],
      createdDateLessThanOrEqualTo: [null],
      createdDateGreaterThan: [null],
      createdDateGreaterThanOrEqualTo: [null],
      createdDate: [null],
      description: [null],
      identityReference: [null],
      latestRoutineMaintenanceDateLessThan: [null],
      latestRoutineMaintenanceDateLessThanOrEqualTo: [null],
      latestRoutineMaintenanceDateGreaterThan: [null],
      latestRoutineMaintenanceDateGreaterThanOrEqualTo: [null],
      latestRoutineMaintenanceDate: [null],
      location: [null],
      manufacturer: [null],
      model: [null],
      nextRoutineMaintenanceRequiredDateLessThan: [null],
      nextRoutineMaintenanceRequiredDateLessThanOrEqualTo: [null],
      nextRoutineMaintenanceRequiredDateGreaterThan: [null],
      nextRoutineMaintenanceRequiredDateGreaterThanOrEqualTo: [null],
      nextRoutineMaintenanceRequiredDate: [null],
      nextRoutineMaintenanceWarningDateLessThan: [null],
      nextRoutineMaintenanceWarningDateLessThanOrEqualTo: [null],
      nextRoutineMaintenanceWarningDateGreaterThan: [null],
      nextRoutineMaintenanceWarningDateGreaterThanOrEqualTo: [null],
      nextRoutineMaintenanceWarningDate: [null],
      purchaseDateLessThan: [null],
      purchaseDateLessThanOrEqualTo: [null],
      purchaseDateGreaterThan: [null],
      purchaseDateGreaterThanOrEqualTo: [null],
      purchaseDate: [null],
      purchasePriceLessThan: [null],
      purchasePriceLessThanOrEqualTo: [null],
      purchasePriceGreaterThan: [null],
      purchasePriceGreaterThanOrEqualTo: [null],
      purchasePrice: [null],
      status: [null],
      updatedBy: [null],
      updatedDateLessThan: [null],
      updatedDateLessThanOrEqualTo: [null],
      updatedDateGreaterThan: [null],
      updatedDateGreaterThanOrEqualTo: [null],
      updatedDate: [null],
      outputFormat: [null],
      download: [null]
    });
  }

  createDataSource(): CrudDataSource<Asset> {
    return new AssetDataSource(this.assetService);
  }

  createServiceArguments(): any {
    return {
      assetId: this.assetIdFilter,
      assetTypeId: this.assetTypeFilter && this.assetTypeFilter.assetTypeId,
      buId: this.businessUnitFilter && this.businessUnitFilter.buId,
      ccId: this.costCentreFilter && this.costCentreFilter.ccId,
      aspectAssetId: this.mechanicalAspectFilter && this.mechanicalAspectFilter.aspectAssetId,
      comments: this.commentsFilter,
      composedAssetClass: this.composedAssetClassFilter,
      createdBy: this.createdByFilter,
      createdDateLessThan: this.createdDateLessThanFilter,
      createdDateLessThanOrEqualTo: this.createdDateLessThanOrEqualToFilter,
      createdDateGreaterThan: this.createdDateGreaterThanFilter,
      createdDateGreaterThanOrEqualTo: this.createdDateGreaterThanOrEqualToFilter,
      createdDate: this.createdDateFilter,
      description: this.descriptionFilter,
      identityReference: this.identityReferenceFilter,
      latestRoutineMaintenanceDateLessThan: this.latestRoutineMaintenanceDateLessThanFilter,
      latestRoutineMaintenanceDateLessThanOrEqualTo: this.latestRoutineMaintenanceDateLessThanOrEqualToFilter,
      latestRoutineMaintenanceDateGreaterThan: this.latestRoutineMaintenanceDateGreaterThanFilter,
      latestRoutineMaintenanceDateGreaterThanOrEqualTo: this.latestRoutineMaintenanceDateGreaterThanOrEqualToFilter,
      latestRoutineMaintenanceDate: this.latestRoutineMaintenanceDateFilter,
      location: this.locationFilter,
      manufacturer: this.manufacturerFilter,
      model: this.modelFilter,
      nextRoutineMaintenanceRequiredDateLessThan: this.nextRoutineMaintenanceRequiredDateLessThanFilter,
      nextRoutineMaintenanceRequiredDateLessThanOrEqualTo: this.nextRoutineMaintenanceRequiredDateLessThanOrEqualToFilter,
      nextRoutineMaintenanceRequiredDateGreaterThan: this.nextRoutineMaintenanceRequiredDateGreaterThanFilter,
      nextRoutineMaintenanceRequiredDateGreaterThanOrEqualTo: this.nextRoutineMaintenanceRequiredDateGreaterThanOrEqualToFilter,
      nextRoutineMaintenanceRequiredDate: this.nextRoutineMaintenanceRequiredDateFilter,
      nextRoutineMaintenanceWarningDateLessThan: this.nextRoutineMaintenanceWarningDateLessThanFilter,
      nextRoutineMaintenanceWarningDateLessThanOrEqualTo: this.nextRoutineMaintenanceWarningDateLessThanOrEqualToFilter,
      nextRoutineMaintenanceWarningDateGreaterThan: this.nextRoutineMaintenanceWarningDateGreaterThanFilter,
      nextRoutineMaintenanceWarningDateGreaterThanOrEqualTo: this.nextRoutineMaintenanceWarningDateGreaterThanOrEqualToFilter,
      nextRoutineMaintenanceWarningDate: this.nextRoutineMaintenanceWarningDateFilter,
      purchaseDateLessThan: this.purchaseDateLessThanFilter,
      purchaseDateLessThanOrEqualTo: this.purchaseDateLessThanOrEqualToFilter,
      purchaseDateGreaterThan: this.purchaseDateGreaterThanFilter,
      purchaseDateGreaterThanOrEqualTo: this.purchaseDateGreaterThanOrEqualToFilter,
      purchaseDate: this.purchaseDateFilter,
      purchasePriceLessThan: this.purchasePriceLessThanFilter,
      purchasePriceLessThanOrEqualTo: this.purchasePriceLessThanOrEqualToFilter,
      purchasePriceGreaterThan: this.purchasePriceGreaterThanFilter,
      purchasePriceGreaterThanOrEqualTo: this.purchasePriceGreaterThanOrEqualToFilter,
      purchasePrice: this.purchasePriceFilter,
      status: this.statusFilter,
      updatedBy: this.updatedByFilter,
      updatedDateLessThan: this.updatedDateLessThanFilter,
      updatedDateLessThanOrEqualTo: this.updatedDateLessThanOrEqualToFilter,
      updatedDateGreaterThan: this.updatedDateGreaterThanFilter,
      updatedDateGreaterThanOrEqualTo: this.updatedDateGreaterThanOrEqualToFilter,
      updatedDate: this.updatedDateFilter
    };
  }
  
  clearFiltersBeforeLoadPage() {
    this.restoreFormFromParams(this.searchForm);
  }
  
  clearFilterVariables() {
    this.assetIdFilter = null;
    this.assetTypeFilter = null;
    this.businessUnitFilter = null;
    this.costCentreFilter = null;
    this.mechanicalAspectFilter = null;
    this.commentsFilter = null;
    this.composedAssetClassFilter = null;
    this.createdByFilter = null;
    this.createdDateLessThanFilter = null;
    this.createdDateLessThanOrEqualToFilter = null;
    this.createdDateGreaterThanFilter = null;
    this.createdDateGreaterThanOrEqualToFilter = null;
    this.createdDateFilter = null;
    this.descriptionFilter = null;
    this.identityReferenceFilter = null;
    this.latestRoutineMaintenanceDateLessThanFilter = null;
    this.latestRoutineMaintenanceDateLessThanOrEqualToFilter = null;
    this.latestRoutineMaintenanceDateGreaterThanFilter = null;
    this.latestRoutineMaintenanceDateGreaterThanOrEqualToFilter = null;
    this.latestRoutineMaintenanceDateFilter = null;
    this.locationFilter = null;
    this.manufacturerFilter = null;
    this.modelFilter = null;
    this.nextRoutineMaintenanceRequiredDateLessThanFilter = null;
    this.nextRoutineMaintenanceRequiredDateLessThanOrEqualToFilter = null;
    this.nextRoutineMaintenanceRequiredDateGreaterThanFilter = null;
    this.nextRoutineMaintenanceRequiredDateGreaterThanOrEqualToFilter = null;
    this.nextRoutineMaintenanceRequiredDateFilter = null;
    this.nextRoutineMaintenanceWarningDateLessThanFilter = null;
    this.nextRoutineMaintenanceWarningDateLessThanOrEqualToFilter = null;
    this.nextRoutineMaintenanceWarningDateGreaterThanFilter = null;
    this.nextRoutineMaintenanceWarningDateGreaterThanOrEqualToFilter = null;
    this.nextRoutineMaintenanceWarningDateFilter = null;
    this.purchaseDateLessThanFilter = null;
    this.purchaseDateLessThanOrEqualToFilter = null;
    this.purchaseDateGreaterThanFilter = null;
    this.purchaseDateGreaterThanOrEqualToFilter = null;
    this.purchaseDateFilter = null;
    this.purchasePriceLessThanFilter = null;
    this.purchasePriceLessThanOrEqualToFilter = null;
    this.purchasePriceGreaterThanFilter = null;
    this.purchasePriceGreaterThanOrEqualToFilter = null;
    this.purchasePriceFilter = null;
    this.statusFilter = null;
    this.updatedByFilter = null;
    this.updatedDateLessThanFilter = null;
    this.updatedDateLessThanOrEqualToFilter = null;
    this.updatedDateGreaterThanFilter = null;
    this.updatedDateGreaterThanOrEqualToFilter = null;
    this.updatedDateFilter = null;
  }
  
  clearFilters() {
    this.clearFilterVariables();
    this.clearFiltersBeforeLoadPage();
    this.loadPage();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedInputEventListener(this.assetIdFilterInput);
    this.addSearchOnChangedSelectEventListener(this.assetTypeFilterInput);
    this.addSearchOnChangedSelectEventListener(this.businessUnitFilterInput);
    this.addSearchOnChangedSelectEventListener(this.costCentreFilterInput);
    this.addSearchOnChangedSelectEventListener(this.mechanicalAspectFilterInput);
    this.addSearchOnChangedInputEventListener(this.commentsFilterInput);
    this.addSearchOnChangedSelectEventListener(this.composedAssetClassFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdByFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.createdDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.descriptionFilterInput);
    this.addSearchOnChangedInputEventListener(this.identityReferenceFilterInput);
    this.addSearchOnChangedInputEventListener(this.latestRoutineMaintenanceDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.latestRoutineMaintenanceDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.latestRoutineMaintenanceDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.latestRoutineMaintenanceDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.latestRoutineMaintenanceDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.locationFilterInput);
    this.addSearchOnChangedInputEventListener(this.manufacturerFilterInput);
    this.addSearchOnChangedInputEventListener(this.modelFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceRequiredDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceRequiredDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceRequiredDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceRequiredDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceRequiredDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceWarningDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceWarningDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceWarningDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceWarningDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.nextRoutineMaintenanceWarningDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchaseDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchaseDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchaseDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchaseDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchaseDateFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchasePriceLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchasePriceLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchasePriceGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchasePriceGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.purchasePriceFilterInput);
    this.addSearchOnChangedSelectEventListener(this.statusFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedByFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateLessThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateGreaterThanOrEqualToFilterInput);
    this.addSearchOnChangedInputEventListener(this.updatedDateFilterInput);
    this.formStorage.rememberFormChanges(this.searchForm);
  }

  ngOnInit() {
    super.ngOnInit();

    this.assetService.exportReportSpecification().subscribe(spec => {
      if (!spec) {
        return;
      }
      this.reportRun.outputFormats = spec.outputFormatsSupported;
      this.reportRun.outputFormat = this.reportRun.outputFormats.find(s => s.name == "XLS") || spec.outputFormatsSupported[0];
      this.reportRun.download = !!this.reportRun.outputFormat.downloadOnly;
    });
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }

  protected initExportOptions(config: any): any {
    config = config || {};
      config.export = config.export || {};
      config.export.options = config.export.options || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initExportOptions(config);
  }
  
  protected transformAllPropertiesToModelSetters(): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    return {
      assetId: (value: number) => self.assetIdFilter = value,
      assetType: (value: AssetType) => { self.assetTypeFilter = value; this.assetTypeChanged(value, false); },
      businessUnit: (value: BusinessUnit) => { self.businessUnitFilter = value; this.businessUnitChanged(value, false); },
      costCentre: (value: CostCentre) => { self.costCentreFilter = value; this.costCentreChanged(value, false); },
      mechanicalAspect: (value: MechanicalAspect) => { self.mechanicalAspectFilter = value; this.mechanicalAspectChanged(value, false); },
      comments: (value: string) => self.commentsFilter = value,
      composedAssetClass: (value: string) => self.composedAssetClassFilter = value,
      createdBy: (value: string) => self.createdByFilter = value,
      createdDateLessThan: (value: Date) => self.createdDateLessThanFilter = value,
      createdDateLessThanOrEqualTo: (value: Date) => self.createdDateLessThanOrEqualToFilter = value,
      createdDateGreaterThan: (value: Date) => self.createdDateGreaterThanFilter = value,
      createdDateGreaterThanOrEqualTo: (value: Date) => self.createdDateGreaterThanOrEqualToFilter = value,
      createdDate: (value: Date) => self.createdDateFilter = value,
      description: (value: string) => self.descriptionFilter = value,
      identityReference: (value: string) => self.identityReferenceFilter = value,
      latestRoutineMaintenanceDateLessThan: (value: Date) => self.latestRoutineMaintenanceDateLessThanFilter = value,
      latestRoutineMaintenanceDateLessThanOrEqualTo: (value: Date) => self.latestRoutineMaintenanceDateLessThanOrEqualToFilter = value,
      latestRoutineMaintenanceDateGreaterThan: (value: Date) => self.latestRoutineMaintenanceDateGreaterThanFilter = value,
      latestRoutineMaintenanceDateGreaterThanOrEqualTo: (value: Date) => self.latestRoutineMaintenanceDateGreaterThanOrEqualToFilter = value,
      latestRoutineMaintenanceDate: (value: Date) => self.latestRoutineMaintenanceDateFilter = value,
      location: (value: string) => self.locationFilter = value,
      manufacturer: (value: string) => self.manufacturerFilter = value,
      model: (value: string) => self.modelFilter = value,
      nextRoutineMaintenanceRequiredDateLessThan: (value: Date) => self.nextRoutineMaintenanceRequiredDateLessThanFilter = value,
      nextRoutineMaintenanceRequiredDateLessThanOrEqualTo: (value: Date) => self.nextRoutineMaintenanceRequiredDateLessThanOrEqualToFilter = value,
      nextRoutineMaintenanceRequiredDateGreaterThan: (value: Date) => self.nextRoutineMaintenanceRequiredDateGreaterThanFilter = value,
      nextRoutineMaintenanceRequiredDateGreaterThanOrEqualTo: (value: Date) => self.nextRoutineMaintenanceRequiredDateGreaterThanOrEqualToFilter = value,
      nextRoutineMaintenanceRequiredDate: (value: Date) => self.nextRoutineMaintenanceRequiredDateFilter = value,
      nextRoutineMaintenanceWarningDateLessThan: (value: Date) => self.nextRoutineMaintenanceWarningDateLessThanFilter = value,
      nextRoutineMaintenanceWarningDateLessThanOrEqualTo: (value: Date) => self.nextRoutineMaintenanceWarningDateLessThanOrEqualToFilter = value,
      nextRoutineMaintenanceWarningDateGreaterThan: (value: Date) => self.nextRoutineMaintenanceWarningDateGreaterThanFilter = value,
      nextRoutineMaintenanceWarningDateGreaterThanOrEqualTo: (value: Date) => self.nextRoutineMaintenanceWarningDateGreaterThanOrEqualToFilter = value,
      nextRoutineMaintenanceWarningDate: (value: Date) => self.nextRoutineMaintenanceWarningDateFilter = value,
      purchaseDateLessThan: (value: Date) => self.purchaseDateLessThanFilter = value,
      purchaseDateLessThanOrEqualTo: (value: Date) => self.purchaseDateLessThanOrEqualToFilter = value,
      purchaseDateGreaterThan: (value: Date) => self.purchaseDateGreaterThanFilter = value,
      purchaseDateGreaterThanOrEqualTo: (value: Date) => self.purchaseDateGreaterThanOrEqualToFilter = value,
      purchaseDate: (value: Date) => self.purchaseDateFilter = value,
      purchasePriceLessThan: (value: number) => self.purchasePriceLessThanFilter = value,
      purchasePriceLessThanOrEqualTo: (value: number) => self.purchasePriceLessThanOrEqualToFilter = value,
      purchasePriceGreaterThan: (value: number) => self.purchasePriceGreaterThanFilter = value,
      purchasePriceGreaterThanOrEqualTo: (value: number) => self.purchasePriceGreaterThanOrEqualToFilter = value,
      purchasePrice: (value: number) => self.purchasePriceFilter = value,
      status: (value: string) => self.statusFilter = value,
      updatedBy: (value: string) => self.updatedByFilter = value,
      updatedDateLessThan: (value: Date) => self.updatedDateLessThanFilter = value,
      updatedDateLessThanOrEqualTo: (value: Date) => self.updatedDateLessThanOrEqualToFilter = value,
      updatedDateGreaterThan: (value: Date) => self.updatedDateGreaterThanFilter = value,
      updatedDateGreaterThanOrEqualTo: (value: Date) => self.updatedDateGreaterThanOrEqualToFilter = value,
      updatedDate: (value: Date) => self.updatedDateFilter = value
    }
  }
  
  restoreFormChanges() {
    const self = this;

    // IMPORTANT that the restoreFormChanges call occurs before the initial search - typically best done in onInitAsyncComplete
    // Whereever a form control binds with [ngModel] to a reactive form, ngModel takes precedence,
    // and needs it's own setter function to set the scope attribute bound
    this.formStorage.restoreFormChanges(this.searchForm, this.transformAllPropertiesToModelSetters());
  }
  
  protected getExportConfig(): any {
    if (this.systemConfig && this.systemConfig.export && this.systemConfig.export.options) {
      return this.systemConfig.export.options;
    }
    return {};
  }
  
  protected getMaxExportResults(): number {
    return this.getExportConfig() && this.getExportConfig().maxExportResults;
  }

  isExportEnabled(): boolean {
    return this.reportRun && this.reportRun.download != null && this.reportRun.outputFormat != null
      && this.pageInfo && this.pageInfo.totalElements != null && this.pageInfo.totalElements > 0
      && (this.getMaxExportResults() == null || this.pageInfo.totalElements <= this.getMaxExportResults());
  }

  exportAction() {
    return this.assetService.exportByFullFiltersAction(this.createServiceArguments(),
      this.reportRun.outputFormat, this.reportRun.download, this.pageSpecification());
  }

  assetIdChanging(value: number, unsetDependents: boolean = true) {}
  
  assetIdChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  assetTypeLoadSelectionList() {
    this.assetTypeService.findAll().subscribe(
      data => {
        this.assetTypeSelectionList = data.items;
      }
    );
  }
  
  assetTypeDisplay(item: AssetType) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return ASSET_TYPE_TYPE.description(item);
  }
  
  assetTypeChanging(value: AssetType, unsetDependents: boolean = true) {}
  
  assetTypeChanged(value: AssetType, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  assetTypeCompare(a: any, b: any) {
    return ASSET_TYPE_METADATA.equals(a, b);
  }
  
  

  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll().subscribe(
      data => {
        this.businessUnitSelectionList = data.items;
      }
    );
  }
  
  businessUnitDisplay(item: BusinessUnit) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return BUSINESS_UNIT_TYPE.description(item);
  }
  
  businessUnitChanging(value: BusinessUnit, unsetDependents: boolean = true) {}
  
  businessUnitChanged(value: BusinessUnit, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  businessUnitCompare(a: any, b: any) {
    return BUSINESS_UNIT_METADATA.equals(a, b);
  }
  
  

  costCentreLoadSelectionList() {
    this.costCentreService.findAll().subscribe(
      data => {
        this.costCentreSelectionList = data.items;
      }
    );
  }
  
  costCentreDisplay(item: CostCentre) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return COST_CENTRE_TYPE.description(item);
  }
  
  costCentreChanging(value: CostCentre, unsetDependents: boolean = true) {}
  
  costCentreChanged(value: CostCentre, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  costCentreCompare(a: any, b: any) {
    return COST_CENTRE_METADATA.equals(a, b);
  }
  
  

  mechanicalAspectLoadSelectionList() {
    this.mechanicalAspectService.findAll().subscribe(
      data => {
        this.mechanicalAspectSelectionList = data.items;
      }
    );
  }
  
  mechanicalAspectDisplay(item: MechanicalAspect) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return MECHANICAL_ASPECT_TYPE.description(item);
  }
  
  mechanicalAspectChanging(value: MechanicalAspect, unsetDependents: boolean = true) {}
  
  mechanicalAspectChanged(value: MechanicalAspect, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }
  
  mechanicalAspectCompare(a: any, b: any) {
    return MECHANICAL_ASPECT_METADATA.equals(a, b);
  }
  
  

  commentsChanging(value: string, unsetDependents: boolean = true) {}
  
  commentsChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  composedAssetClassLoadSelectionList() {
    this.refCodeStorage.getDomainElements('SYSTEM_COMPOSED_ASSET_CLASS').subscribe(
      data => {
        this.composedAssetClassSelectionList = data;
      }
    );
  }

  composedAssetClassChanging(value: string, unsetDependents: boolean = true) {}
  
  composedAssetClassChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdByChanging(value: string, unsetDependents: boolean = true) {}
  
  createdByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  createdDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  createdDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  descriptionChanging(value: string, unsetDependents: boolean = true) {}
  
  descriptionChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  identityReferenceChanging(value: string, unsetDependents: boolean = true) {}
  
  identityReferenceChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  latestRoutineMaintenanceDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  latestRoutineMaintenanceDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  latestRoutineMaintenanceDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  latestRoutineMaintenanceDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  latestRoutineMaintenanceDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  latestRoutineMaintenanceDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  latestRoutineMaintenanceDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  latestRoutineMaintenanceDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  latestRoutineMaintenanceDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  latestRoutineMaintenanceDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  locationChanging(value: string, unsetDependents: boolean = true) {}
  
  locationChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  manufacturerChanging(value: string, unsetDependents: boolean = true) {}
  
  manufacturerChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  modelChanging(value: string, unsetDependents: boolean = true) {}
  
  modelChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceRequiredDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceRequiredDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceRequiredDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceRequiredDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceRequiredDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceRequiredDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceRequiredDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceRequiredDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceRequiredDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceRequiredDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceWarningDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceWarningDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceWarningDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceWarningDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceWarningDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceWarningDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceWarningDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceWarningDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  nextRoutineMaintenanceWarningDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  nextRoutineMaintenanceWarningDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchaseDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  purchaseDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchaseDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  purchaseDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchaseDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  purchaseDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchaseDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  purchaseDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchaseDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  purchaseDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchasePriceChanging(value: number, unsetDependents: boolean = true) {}
  
  purchasePriceChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchasePriceLessThanChanging(value: number, unsetDependents: boolean = true) {}
  
  purchasePriceLessThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchasePriceLessThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  purchasePriceLessThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchasePriceGreaterThanChanging(value: number, unsetDependents: boolean = true) {}
  
  purchasePriceGreaterThanChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  purchasePriceGreaterThanOrEqualToChanging(value: number, unsetDependents: boolean = true) {}
  
  purchasePriceGreaterThanOrEqualToChanged(value: number, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  statusLoadSelectionList() {
    this.refCodeStorage.getDomainElements('ASSET_STATUS').subscribe(
      data => {
        this.statusSelectionList = data;
      }
    );
  }

  statusChanging(value: string, unsetDependents: boolean = true) {}
  
  statusChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedByChanging(value: string, unsetDependents: boolean = true) {}
  
  updatedByChanged(value: string, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateLessThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateLessThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  updatedDateGreaterThanOrEqualToChanging(value: Date, unsetDependents: boolean = true) {}
  
  updatedDateGreaterThanOrEqualToChanged(value: Date, unsetDependents: boolean = true) {
    /*
    if (unsetDependents) {
      this.depdendentField.setValue(null);
    }
    dependentFieldLoadSelectionList();
    */
  }

  disabledTooltip(element) {
    if (!element) {
      return true;
    }
    return element.valid || !element.touched;
  }

  get assetId() {
    return this.searchForm && this.searchForm.get('assetId');
  }

  get assetType() {
    return this.searchForm && this.searchForm.get('assetType');
  }

  get businessUnit() {
    return this.searchForm && this.searchForm.get('businessUnit');
  }

  get costCentre() {
    return this.searchForm && this.searchForm.get('costCentre');
  }

  get electricalAspect() {
    return this.searchForm && this.searchForm.get('electricalAspect');
  }

  get maintenanceAspect() {
    return this.searchForm && this.searchForm.get('maintenanceAspect');
  }

  get mechanicalAspect() {
    return this.searchForm && this.searchForm.get('mechanicalAspect');
  }

  get comments() {
    return this.searchForm && this.searchForm.get('comments');
  }

  get composedAssetClass() {
    return this.searchForm && this.searchForm.get('composedAssetClass');
  }

  get createdBy() {
    return this.searchForm && this.searchForm.get('createdBy');
  }

  get createdDate() {
    return this.searchForm && this.searchForm.get('createdDate');
  }

  get createdDateLessThan() {
    return this.searchForm && this.searchForm.get('createdDateLessThan');
  }
  
  get createdDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateLessThanOrEqualTo');
  }
  
  get createdDateGreaterThan() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThan');
  }
  
  get createdDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('createdDateGreaterThanOrEqualTo');
  }

  get description() {
    return this.searchForm && this.searchForm.get('description');
  }

  get identityReference() {
    return this.searchForm && this.searchForm.get('identityReference');
  }

  get latestRoutineMaintenanceDate() {
    return this.searchForm && this.searchForm.get('latestRoutineMaintenanceDate');
  }

  get latestRoutineMaintenanceDateLessThan() {
    return this.searchForm && this.searchForm.get('latestRoutineMaintenanceDateLessThan');
  }
  
  get latestRoutineMaintenanceDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('latestRoutineMaintenanceDateLessThanOrEqualTo');
  }
  
  get latestRoutineMaintenanceDateGreaterThan() {
    return this.searchForm && this.searchForm.get('latestRoutineMaintenanceDateGreaterThan');
  }
  
  get latestRoutineMaintenanceDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('latestRoutineMaintenanceDateGreaterThanOrEqualTo');
  }

  get location() {
    return this.searchForm && this.searchForm.get('location');
  }

  get manufacturer() {
    return this.searchForm && this.searchForm.get('manufacturer');
  }

  get model() {
    return this.searchForm && this.searchForm.get('model');
  }

  get nextRoutineMaintenanceRequiredDate() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceRequiredDate');
  }

  get nextRoutineMaintenanceRequiredDateLessThan() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceRequiredDateLessThan');
  }
  
  get nextRoutineMaintenanceRequiredDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceRequiredDateLessThanOrEqualTo');
  }
  
  get nextRoutineMaintenanceRequiredDateGreaterThan() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceRequiredDateGreaterThan');
  }
  
  get nextRoutineMaintenanceRequiredDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceRequiredDateGreaterThanOrEqualTo');
  }

  get nextRoutineMaintenanceWarningDate() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceWarningDate');
  }

  get nextRoutineMaintenanceWarningDateLessThan() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceWarningDateLessThan');
  }
  
  get nextRoutineMaintenanceWarningDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceWarningDateLessThanOrEqualTo');
  }
  
  get nextRoutineMaintenanceWarningDateGreaterThan() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceWarningDateGreaterThan');
  }
  
  get nextRoutineMaintenanceWarningDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('nextRoutineMaintenanceWarningDateGreaterThanOrEqualTo');
  }

  get purchaseDate() {
    return this.searchForm && this.searchForm.get('purchaseDate');
  }

  get purchaseDateLessThan() {
    return this.searchForm && this.searchForm.get('purchaseDateLessThan');
  }
  
  get purchaseDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('purchaseDateLessThanOrEqualTo');
  }
  
  get purchaseDateGreaterThan() {
    return this.searchForm && this.searchForm.get('purchaseDateGreaterThan');
  }
  
  get purchaseDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('purchaseDateGreaterThanOrEqualTo');
  }

  get purchasePrice() {
    return this.searchForm && this.searchForm.get('purchasePrice');
  }

  get purchasePriceLessThan() {
    return this.searchForm && this.searchForm.get('purchasePriceLessThan');
  }
  
  get purchasePriceLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('purchasePriceLessThanOrEqualTo');
  }
  
  get purchasePriceGreaterThan() {
    return this.searchForm && this.searchForm.get('purchasePriceGreaterThan');
  }
  
  get purchasePriceGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('purchasePriceGreaterThanOrEqualTo');
  }

  get status() {
    return this.searchForm && this.searchForm.get('status');
  }

  get updatedBy() {
    return this.searchForm && this.searchForm.get('updatedBy');
  }

  get updatedDate() {
    return this.searchForm && this.searchForm.get('updatedDate');
  }

  get updatedDateLessThan() {
    return this.searchForm && this.searchForm.get('updatedDateLessThan');
  }
  
  get updatedDateLessThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateLessThanOrEqualTo');
  }
  
  get updatedDateGreaterThan() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThan');
  }
  
  get updatedDateGreaterThanOrEqualTo() {
    return this.searchForm && this.searchForm.get('updatedDateGreaterThanOrEqualTo');
  }


}



